import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { url } from "../../../services/constant";
import {
  CurveHolder,
  Span,
  StyledText,
  Button,
  MainHolder,
  Children,
  Body,
} from "../../../components/common/basic";
import {
  Time as TimeIcon,
  CheckCirclIcon, Curve, Timer
} from "../../../components/svgs";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

import { useTheme, useLoyalty } from "../../../hooks";
import CheckCircleIcon from "../../../components/svgs/checkCircleIcon";
import { BackButton } from "../../../components/common";
import RewardItemCard from "../mashupnwin/components/RewardItemCard";

const CapturenShareOrderStatus = () => {
  const [activeReward, setActiveReward] = useState();

  const history = useHistory();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const id = params.get('id');

  const { captureEntries } = useLoyalty();

  useEffect(() => {
    if (!!captureEntries?.length && id) {
      const foundEntry = captureEntries.find(entry => entry._id == id);
      setActiveReward(foundEntry);
    }
  }, [id, captureEntries]);

  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "CaptureAndShareOrderStatus",
        firebase_screen_class: "CaptureAndShareOrderStatus",
      })
    );
  }, []);

  return (
    <>
      <MainHolder>
        <BackButton onClick={() => history.goBack()} />
        <Children>
          <Header>
            <StyledText size={24}>Track reward</StyledText>
          </Header>
          <Body>
            <div style={{ boxSizing: 'border-box', padding: '0 15px' }}>
              {
                <>
                  <RewardItemCard
                    color={"#000"}
                    image={activeReward?.uri}
                    name={activeReward?.item}
                    points={"Won"}
                    showStatus={true}
                    status={'pending'}
                  />
                  <StyledText size={11}>
                    <span style={{ color: '#7F7F7F', fontFamily: 'MTNRegular' }}>Pickup point </span>
                    {activeReward?.pickup}
                  </StyledText>
                  <hr style={{ margin: '15px 0', borderTop: 'none', borderBottom: '1px solid #ddd' }} />

                  <StyledText size={18}>Delivery Status</StyledText>
                  <OrderStatusCard
                    location={activeReward?.pickup}
                    stage={null}
                    enrouteDate={null}
                    completedDate={null}
                  />
                </>
              }
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

// TODO: Move to loyalty components
const OrderStatusCard = ({ location, stage }) => {
  return (
    <>
      <div style={{ paddingLeft: '7px', boxSizing: 'border-box' }}>
        <OrderStatusStage isCompleted={stage === 'ready' || stage === 'in-progress'}>
          <StyledText size={12} style={{ margin: '0 0 5px 0', fontFamily: 'MTNRegular' }}>
            Voucher Enroute to
            <span style={{ color: '#E31C79' }}> {location}</span>
          </StyledText>
          {
            (stage === 'ready' || stage === 'in-progress') &&
            <StyledText size={10} color="#828282" style={{ margin: 0, fontFamily: 'MTNRegular' }}>28/07/2022  09:54</StyledText>}
        </OrderStatusStage>

        <OrderStatusStage isCompleted={stage === 'ready'} isLast={true}>
          <StyledText size={12} style={{ margin: '0 0 5px 0', fontFamily: 'MTNRegular' }}>
            Voucher Ready for Pickup
          </StyledText>
          {
            stage === 'ready' &&
            <StyledText size={10} color="#828282" style={{ margin: 0, fontFamily: 'MTNRegular' }}>28/07/2022  09:54</StyledText>
          }
        </OrderStatusStage>
      </div>
      <div style={{
        display: 'flex',
        background: stage !== 'ready' ? '#FFCD00' : '#0FAF4B',
        color: stage !== 'ready' ? '#000' : '#fff',
        padding: '20px',
        borderRadius: '10px',
        justifyContent: 'space-around'
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {stage !== 'ready' ? <TimeIcon width={28} /> : <CheckCirclIcon color="#0FAF4B" fill="white" width={28} />}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', padding: '0 5px', width: '80%' }}>
          <div>
            <StyledText size={18} style={{ margin: '0 0 3px 0' }}>{stage !== 'ready' ? 'Pending' : 'Ready'}</StyledText>
            <StyledText size={10} style={{ margin: '0', fontFamily: 'MTNRegular' }}>
              {
                stage !== 'ready' ?
                  'You will be notified when your order is ready' : 'Visit selected MTN Office to pickup reward'
              }
            </StyledText>
          </div>
        </div>
      </div>
    </>
  )
}

const OrderStatusStage = ({ children, isCompleted, isLast }) => {
  return (
    <div style={{
      borderLeft: `2px solid ${isLast ? '#fff' : '#BDBDBD'}`,
      padding: '0 0 30px 20px',
      boxSizing: 'border-box',
      position: 'relative'
    }}
    >
      <div style={{
        background: '#BDBDBD',
        boxSizing: 'border-box',
        position: "absolute",
        height: '16px', width: '16px',
        borderRadius: '20px',
        top: 0,
        left: '-9px'
      }}>
        {isCompleted && <CheckCircleIcon width={16} fill={'#0FAF4B'} />}
      </div>
      {children}
    </div>
  )
}

const Header = styled.div`
  width: 100%;
  min-height: 40px;
  max-height: 300px;
  overflow: hidden;
  position: relative;
  text-align: center;
`;

const generateStyles = () => {
  return {
    textStyle: {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
  };
};

export default CapturenShareOrderStatus;
